<template>
  <div class="password">
    <template v-if="showPassword">
      <input
        id="password-field"
        v-model="sync_password"
        type="text"
        aria-label="Password"
        :class="[{ 'form-field--invalid': validation }, 'password-field', 'form-field']"
        :placeholder="placeholder"
        maxlength="72"
        :disabled="disabled"
        @keyup.enter="emitSubmit"
      />
    </template>
    <template v-else>
      <input
        id="password-field"
        v-model="sync_password"
        type="password"
        aria-label="Password"
        :class="[{ 'form-field--invalid': validation }, 'password-field', 'form-field']"
        :placeholder="placeholder"
        maxlength="72"
        :disabled="disabled"
        @keyup.enter="emitSubmit"
      />
    </template>
    <button
      id="visibility-password-field"
      class="password-field-button"
      @click="toggleVisibility"
    >
      {{ visibilityButtonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PasswordField',
  props: ['password', 'placeholder', 'validation', 'disabled'],
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    visibilityButtonText() {
      return this.showPassword ? 'Hide' : 'Show'
    },
    sync_password: {
      get() {
        return this.password
      },
      set(value) {
        this.$emit('update:password', value)
      },
    },
  },
  methods: {
    toggleVisibility() {
      this.showPassword = !this.showPassword
    },
    emitSubmit() {
      this.$emit('password-submit')
    },
  },
}
</script>

<style lang="scss" scoped>
.password {
  position: relative;
  @include flex-display();
  @include flex-align-items(center);
  margin-top: 0.5em;
  font-size: 13.3333px; //Equal to default input text size
  &-field {
    width: 100%;
    margin: 0;
    &-button {
      position: absolute;
      right: 1.5em;
      padding: 0;
      border: none;
      background: transparent;
      text-transform: uppercase;
      font-size: $small-font;
      font-weight: 600;
      color: $blue;
      outline: none;
      transition: transform 0.2s ease-in-out;
      &:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
  }
}
</style>
